import { EnumSchema } from '../metadata-schema';

export const TussentijdseUitstroomVSO: EnumSchema = {
	"type": "string",
	"title": "TussentijdseUitstroomVSO",
	"enum": [
		"Regulier onderwijs",
		"Speciaal onderwijs"
	]
};
